import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../logo.png";
import NavDrawer from "./NavDrawer";
import styles from "./Navigation.module.css";
const Navigation = () => {
  const { pathname } = useLocation();
  const [navToggler, setToggler] = useState(false);
  const [navBg, setNavBg] = useState(false);
  const navTogglerHandler = () => {
    setToggler(!navToggler);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 10) {
      setNavBg(true);
    } else {
      setNavBg(false);
    }
  };
  window.removeEventListener("scroll", handleScroll);
  const handleBackdrawer = () => {
    setToggler(false);
  };

  const navTogglerClass = navToggler
    ? styles.nav_sidebar + " " + styles.showNav
    : styles.nav_sidebar;

  return (
    <header
      className={
        navBg ? styles.app_header + " " + styles.header_bg : styles.app_header
      }
    >
      {navToggler && (
        <div className={styles.backdrawer} onClick={handleBackdrawer}></div>
      )}
      <div className="navigation">
        <div className="container-fluid">
          <div className="row">
            <div className="col-2 d-lg-none m-auto px-0">
              <button
                type="button"
                className="btn  d-block shadow-none "
                onClick={navTogglerHandler}
              >
                <span className={styles.bar_icon}>
                  <i className="fa fa-bars text-white"></i>
                </span>
              </button>
            </div>
            <div className="col-10 col-lg-3 my-auto">
              <NavLink
                to="/"
                className={`  navbar-brand m-0 d-block  mw-100 ${styles.app_logo}`}
              >
                <img
                  src={logo}
                  className="mw-100 d-block ml-auto mr-lg-auto"
                  alt="logo"
                />
              </NavLink>
            </div>

            <div className="col-9 d-none d-lg-flex">
              <NavDrawer
                pathname={pathname}
                navTogglerClass="navbar  px-2 w-100"
                navTogglerHandler={navTogglerHandler}
              />
            </div>
            <div className="col-9 d-block d-lg-none">
              <NavDrawer
                navTogglerClass={navTogglerClass}
                navTogglerHandler={navTogglerHandler}
                navToggler={navToggler}
                pathname={pathname}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navigation;
